import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { Ticket, ListChecks, Activity } from 'lucide-react';
import OpsDashboard from './OpsDashboard';
import RaiseTicket from './RaiseTicket';
import TicketDetail from './TicketDetail';
import TrackTickets from './TrackTickets';

const TICKET_CHIPS = [
  { to: '/tickets/raise', label: 'Raise Ticket', Icon: Ticket },
  { to: '/tickets/track', label: 'Track Tickets', Icon: ListChecks },
  { to: '/tickets/dashboard', label: 'Ops Dashboard', Icon: Activity },
];

export default function TicketTracker() {
  return (
    <>
      <div className="mb-3 flex flex-wrap items-center justify-end gap-3">
        <div className="flex flex-wrap items-center justify-end gap-2">
        {TICKET_CHIPS.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-sm font-medium transition-all ${
                isActive
                  ? 'border-blue-500 bg-blue-50 text-blue-600'
                  : 'border-gray-300 bg-white text-slate-600 hover:text-blue-600'
              }`
            }
          >
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
        </div>
      </div>

      <Routes>
        <Route index element={<Navigate to="/tickets/raise" replace />} />
        <Route path="raise" element={<RaiseTicket />} />
        <Route path="track" element={<TrackTickets />} />
        <Route path="dashboard" element={<OpsDashboard />} />
        <Route path="view/:id" element={<TicketDetail />} />
      </Routes>

      <p className="mt-2 text-center text-xs text-slate-400">
        SLA: respond within 48h · resolve within 5 days · standard operations only
      </p>
    </>
  );
}